import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var AddDocumentsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AddDocumentsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
   * Get users list for given query params
   *
   * @since 1.0.0
   *
   * @param [start] Query left offset
   * @param [limit] Results number
   * @param [sort] Sorting field name
   * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
   * @param [search] Filtering object with fildering data string
   */
    AddDocumentsService.prototype.getList = function (start, limit, sort, sortVersus, search, active) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus, active: active };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'properties/no-cheklist', params);
    };
    AddDocumentsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AddDocumentsService_Factory() { return new AddDocumentsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: AddDocumentsService, providedIn: "root" });
    return AddDocumentsService;
}());
export { AddDocumentsService };
